import { render, staticRenderFns } from "./Talk.vue?vue&type=template&id=07706602&scoped=true"
import script from "./Talk.vue?vue&type=script&lang=js"
export * from "./Talk.vue?vue&type=script&lang=js"
import style1 from "./Talk.vue?vue&type=style&index=1&id=07706602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07706602",
  null
  
)

export default component.exports